import { render, staticRenderFns } from "./BkzxList.vue?vue&type=template&id=6eabede2&scoped=true"
import script from "./BkzxList.vue?vue&type=script&lang=js"
export * from "./BkzxList.vue?vue&type=script&lang=js"
import style0 from "./BkzxList.vue?vue&type=style&index=0&id=6eabede2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eabede2",
  null
  
)

export default component.exports